import React from 'react';
import { Box } from '@heycater/design-system';
import { BoxProps } from '@material-ui/core';
import styled from 'styled-components';

import BitkomIcon from '@icons/logo/bitkom.svg';
import CAndAIcon from '@icons/logo/c-and-a.svg';
import CelonisIcon from '@icons/logo/celonis2.svg';
import CosmocultIcon from '@icons/logo/cosmoconsult.svg';
import DoctolibIcon from '@icons/logo/docotlib.svg';
import HelloFreshIcon from '@icons/logo/helloFresh.svg';
import SumupIcon from '@icons/logo/sumup.svg';
import TaxFixIcon from '@icons/logo/taxfix.svg';

const Customers = ({ ...props }: BoxProps) => {
  return (
    <Wrapper {...props}>
      <LogosWrapper>
        <SumupIcon className="logo__icon logo__icon--sumup" />
        <CosmocultIcon className="logo__icon logo__icon--cosmo" />
        <CelonisIcon className="logo__icon logo__icon--celonis" />
        <DoctolibIcon className="logo__icon logo__icon--doctolib" />
        <CAndAIcon className="logo__icon logo__icon--c&a" />
        <BitkomIcon className="logo__icon logo__icon--bitkom" />
        <HelloFreshIcon className="logo__icon logo__icon--helloFresh" />
        <TaxFixIcon className="logo__icon logo__icon--taxfix" />
      </LogosWrapper>
    </Wrapper>
  );
};

const Wrapper = styled(Box)`
  align-items: center;

  display: flex;
  gap: ${({ theme }) => theme.spacing(3)}px;
  flex-direction: column;
  max-width: 100%;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    flex-direction: row;
    gap: 3vw;
  }
`;

const LogosWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(2)}px;
  column-gap: ${({ theme }) => theme.spacing(3)}px;

  .logo__icon {
    height: 20px;
    flex-grow: 0;
    flex-shrink: 0;

    ${({ theme }) => theme.breakpoints.up('sm')} {
      height: 26px;

      &--cosmo {
        padding: 2px;
      }

      &--doctolib {
        padding: 3px;
      }
      &--bitkom {
        padding: 5px;
      }

      &--taxfix {
        padding: 3px;
      }

      &--helloFresh {
        padding: 3px;
      }
    }

    ${({ theme }) => theme.breakpoints.up('lg')} {
      height: 30px;
    }
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    gap: ${({ theme }) => theme.spacing(5)}px;
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    flex-wrap: nowrap;
    gap: 2vw;
  }

  ${({ theme }) => theme.breakpoints.up(1480)} {
    gap: 2.5vw;
  }
`;

export default Customers;
